//* 组件属性
import type { TutorialProps } from "../index";

//* 样式
import css_father from "../../../style/index.module.less";

export const useComposable = (define: TutorialProps) => {
    //* 插件
    const i18n = useI18n();

    const options = {
        gene: {
            tool: i18n.t("GeneticComparison"),
            mode: i18n.t("Gene"),
            image1:
                i18n.locale.value === "en"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/9a7320fe-6069-4de3-9dbc-9b9120725334.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/0c2699c4-b842-47ac-9fe7-2aed673d79bd.webp?v=1",
            image2:
                i18n.locale.value === "en"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/992486e5-be63-49f1-b048-70dccc73b5ab.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/4dc98eec-1a3c-422b-beda-f001ea9e87bf.webp",

            image3:
                i18n.locale.value === "en"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/5d2b888e-5333-418e-8a78-29ef24fb6406.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/bd81a14a-c0db-492c-9bc4-cdc37ceb3636.webp",
        },
        disease: {
            tool: i18n.t("DiseasesComparison"),
            mode: i18n.t("Disease"),
            image1:
                i18n.locale.value === "en"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/3e5395d5-e210-4ead-b9cd-1310cc64544d.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/19199284-5687-4001-9f59-0522090f87cd.webp",
            image2: "https://rdgta.cdn.cyagen.com/rddc/pictures/a6de9a14-ba88-4b15-b5be-a3108c6ca7d5.webp",

            image3: "https://rdgta.cdn.cyagen.com/rddc/pictures/9731dfa6-a767-4477-8b52-c2009710d08a.webp",
        },
        model: {
            tool: i18n.t("ModelComparison"),
            mode: i18n.t("Model"),
            image1:
                i18n.locale.value === "en"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/a7398fa6-e213-4734-93d9-1b6944c6c5f0.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/e54048c7-08e8-43a7-bacc-5a4d0592bc22.webp",
            image2: "https://rdgta.cdn.cyagen.com/rddc/pictures/3a7609f2-e864-4bc4-97b4-e20f4e85dd4f.webp",

            image3: "https://rdgta.cdn.cyagen.com/rddc/pictures/a6b9a1da-a81f-4d6c-b206-de010db4f2d1.webp",
        },
    };

    //* 静态变量
    const vars = {
        observer: shallowRef<ResizeObserver>(),
        steps: [
            {
                step: i18n.t("Step1"),
                contents: [
                    i18n.t("ComparisonStep1", { tool: options[define.mode].tool, mode: options[define.mode].mode }),
                    i18n.t("ComparisonStep1_2", { mode: options[define.mode].mode }),
                ],
                image: options[define.mode].image1,
            },
            {
                step: i18n.t("Step2"),
                contents: [i18n.t("ComparisonStep2", { mode: options[define.mode].mode })],
                image: options[define.mode].image2,
            },
            {
                step: i18n.t("Step3"),
                contents: [i18n.t("ComparisonStep3", { mode: options[define.mode].mode })],
                image: options[define.mode].image3,
            },
        ],
    };

    //* 响应式变量
    const refs = {
        show: ref<boolean>(false),
        step: ref<number>(1),
        mainStyles: ref<any>({}),
        rect: ref<any>(),
    };

    //* 函数列表
    const methods = {
        open: () => {
            refs.show.value = true;
            refs.step.value = 1;
            window.scrollTo({ top: 0 });
            document.body.style.overflow = "hidden";
            methods.render();
        },

        close: () => {
            refs.show.value = false;
            document.body.style.overflow = "";
        },

        change: (type: "prev" | "next") => {
            if (type == "prev") {
                refs.step.value--;
            } else {
                refs.step.value++;
            }
            methods.render();
        },
        render: () => {
            refs.rect.value = document
                .querySelectorAll("." + css_father.control)
                [refs.step.value > 2 ? 2 : 1].firstElementChild?.getBoundingClientRect();
        },
    };

    const style = reactive({
        main: computed(() => {
            if (refs.rect.value) {
                return {
                    top: `${refs.rect.value.top - 11}px`,
                    left: `${refs.rect.value.left - 19}px`,
                };
            }
            return {};
        }),
    });

    return { refs, vars, methods, style };
};
